import { Table } from '@gate/gui'
import { Flex } from '@mantine/core'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

export interface SorterTableTitleProps {
  children?: ReactNode
  sortCallback: () => void
  type?: '+' | '-'
}

export const SorterTitleStyled = styled.div`
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  /* padding: 0 6px; */
  /* margin-left: 12px; */
  color: var(--color-text-3);
  .icon-4 {
    color: var(--color-icon-4);
  }
  .icon-brand-1 {
    color: var(--color-icon-1);
  }
  svg {
    font-size: 8px;
    width: 8px;
    height: 8px;
  }
`

const SorterTitle: FC<SorterTableTitleProps> = ({ children, sortCallback, type }) => {
  return (
    <SorterTitleStyled>
      {children}
      <Flex ml="4px" direction="column" onClick={sortCallback}>
        <Table.Ascend width={8} height={8} className={`${type === '+' ? 'icon-brand-1' : 'icon-4 '}`} />
        <Table.Descend width={8} height={8} className={`${type === `-` ? 'icon-brand-1' : 'icon-4 '}`} />
      </Flex>
    </SorterTitleStyled>
  )
}

export default SorterTitle
